import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes";
import { MenuProvider } from "./context/menuContext";
import { CredentialProvider } from "./context/credential";

function App() {
  return (
    <>
      <Router basename="/">
        <CredentialProvider>
          <MenuProvider>
            <Routes />
          </MenuProvider>
        </CredentialProvider>
      </Router>
    </>
  );
}

export default App;
